import { render, staticRenderFns } from "./KeybeDate.vue?vue&type=template&id=1836b787&scoped=true&"
import script from "./KeybeDate.vue?vue&type=script&lang=ts&"
export * from "./KeybeDate.vue?vue&type=script&lang=ts&"
import style0 from "./KeybeDate.vue?vue&type=style&index=0&id=1836b787&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1836b787",
  null
  
)

export default component.exports